import styled from 'styled-components'

const Main = styled.main`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export default Main
